// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1jeIm","unreadBadge":"styles_unreadBadge__23KZm","modalContent":"styles_modalContent__1C0sn","modal":"styles_modal__2T4Lb"};